export default "__VITE_ASSET__CXVBcW3R__"